<template>
   <div class="content-wrapper pl-3 pr-3 pb-3 pt-3 mb-2" style="height: inherit; width:inherit;">
    <!-- Content Header (Page header) -->
        <div v-if="$gate.isBuyer()">
<!-- Whatever VUE CONTENT: PLACE IT AFTER THIS COMMENT -->
            
    <section class="content-header">
        <div class="container-fluid">
          <div class="row mb-2">
            <div class="col-sm-6">
              <h2>Upcoming Auctions</h2>
            </div>
            <div class="col-sm-6">
              <ol class="breadcrumb float-sm-right">
                <li class="breadcrumb-item"><a href="/home">Home</a></li>
                <li class="breadcrumb-item active">{{ $route.meta.title }}</li>
              </ol>
            </div>
          </div>
        </div><!-- /.container-fluid -->
      </section>

    <!-- Main content -->
<section class="content">
<!-- main row for all icons  -->
<div class="col-md-12">
	<div class="card card-primary card-outline">
		<div class="card-body overflow-auto">
      <img v-if="auctions==''" src="../images/nodata.svg">
			<datatable style="margin-top:1%;" :columns="columns" :sortKey="sortKey" :sortOrders="sortOrders" @sort="sortBy" v-else>
      	<tbody>
        	<tr v-if="auctions!=''" v-for="auction in auctions" :key="auction.id">
        		<td>{{auction.auction_id}}</td>
          	<td>{{auction.name}}</td>
          	<td>{{auction.description}}</td>
          	<td>{{auction.schedule_start}}</td>
          	<td>{{auction.schedule_end}}</td>
          	<td>{{auction.status}}</td>
          	<td>
          		<button class="btn btn-primary fa fa-info" @click="addModal(auction.id)"></button>
          	</td>
          </tr>	
        </tbody>
      </datatable>	
    </div>
    <div class="card-footer">
    	<pagination :pagination="pagination"
       	@prev="getAuctions(pagination.prevPageUrl)"
        @next="getAuctions(pagination.nextPageUrl)"
      ></pagination>
		</div>
	</div>
</div>
</section>
    <!-- /.content -->
<div class="modal" tabindex="-1" role="dialog" id="addModal">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Auction Lots</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
      	<table class="table table-striped">
  <thead>
    <tr>
      <th scope="col">Lot Name</th>
      <th scope="col">Color</th>
      <th scope="col">Status</th>
      <th scope="col">Auto Bid</th>
      <th scope="col">Manage</th>
    </tr>
  </thead>
  <tbody>
    <tr v-for="(g, index) in auction_lots">
      <th scope="row" >{{g.lot_name}}</th>
      <td>{{g.color}}</td>
      <td>{{g.status}}</td>
      <td>
      	<span class="badge badge-success" v-if="g.auto_bid == true">Active</span>
      	<span class="badge badge-danger" v-else>Not Set</span>
      </td>
      <td>
      	<button class="btn btn-primary fa fa-info" @click="details(g.lot_id)"></button>
      	<button class="btn btn-primary fa fa-arrow-up" @click="autoModal(g.id)"></button>
      	<button class="btn btn-warning fa fa-star" @click="favourite(g.id, g.auction_id)"></button>
      </td>
    </tr>
    
  </tbody>
</table>
      </div>
      <div class="modal-footer">
      	<button class="btn btn-secondary" data-dismiss="modal">Close</button>
      </div>
    </div>
	</div>
</div>

<div class="modal" tabindex="-1" role="dialog" id="autoModal">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Lot Auto Bid Settings</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
      	<input type="number" pattern="[0-9]" placeholder="Enter starting price" class="form-control" v-model="form.starting_quote_price" min="1">
      	<input type="number" pattern="[0-9]" placeholder="Enter maximum price" class="form-control" v-model="form.upper_quote_price" min="1">
      	<input type="number" pattern="[0-9]" placeholder="Enter increment" class="form-control" v-model="form.increment" min="1">
      </div>
      <div class="modal-footer">
      	<button class="btn btn-secondary" data-dismiss="modal">Close</button>
      	<button class="btn btn-primary" @click="setAutoBid">Set</button>
      </div>
    </div>
	</div>
</div>
<br>
      <br>
<!-- All VUE Parts end before this comment -->
        </div>
        <div v-if="!$gate.isBuyer()">
             <access-denied></access-denied>
        </div>
    </div>
</template>

<script>
    import Datatable from '../datatable.vue';
    import Pagination from '../pagination.vue';
    export default {
        mounted() {
            console.log('Component mounted.')
        },
        
        components: {datatable:Datatable, pagination:Pagination},
        
        
        created(){
        	this.getAuctions();
        	this.getAvailableLots();
        },
        
    		data(){
        	let sortOrders = {};
      		let columns = [
      			{width:'20%', label:'ID', name:'auction_id'},
      			{width:'10%', label:'Name', name:'name'},
      			{width:'20%', label:'Description', name:'description'},
      			{width:'15%', label:'Start', name:'schedule_start'},
      			{width:'15%', label:'End', name:'schedule_end'},
      			{width:'10%', label: 'Status', name:'status'},
      			{width:'10%', label:'Manage', name:'ops'}
      		];
      		columns.forEach((column) => {
          	sortOrders[column.name]=-1;
        	});
        	return{
        		columns: columns,
        		sortKey: 'id',
        		sortOrders: sortOrders,
        		tableData: {
        			draw: 0,
        			length: 10,
        			column: 0,
        			dir: 'desc'
        		},
        		pagination: {
          		lastPage: '',
           		currentPage: '',
            	total: '',
            	lastPageUrl: '',
            	nextPageUrl: '',
            	prevPageUrl: '',
            	from: '',
            	to: '',
         		},
         		auctions: [],
         		errors: [],
         		auction_lots: [],
         		lots: [],
         		lot_id: '',
         		auction_id: '',
         		
         		form: new Form({
         			starting_quote_price: '',
         			upper_quote_price: '',
         			increment: 1,
         			buyer_id: this.$userId,
         			auction_lot_id: '',
         			buyer_id: this.$userId,
         			id: ''
         		})
         }
       },
       
       methods: {
       	configPagination(data){
      		this.pagination.lastPage=data.lastPage;
         	this.pagination.currentPage=data.current_page;
    	  	this.pagination.total=data.total;
        	this.pagination.lastPageUrl=data.last_page_url;
       		this.pagination.nextPageUrl=data.next_page_url;
       		this.pagination.prevPageUrl=data.prev_page_url;
     		 	this.pagination.from=data.from;
        	this.pagination.to=data.to;
    		},
  
      	sortBy(key){
     			this.sortKey=key;
      		this.sortOrders[key] = this.sortOrders[key]*-1;
       	  this.tableData.column = this.getIndex(this.columns, 'name', key);
 	     	  this.tableData.dir = this.sortOrders[key] === 1 ? 'asc' : 'desc';
    		},
     		
     		getIndex(array, key, value){
       		return array.findIndex(i => i[key] == value)
       	},
       	
       	getAuctions(url="/api/getAvailableAuctions"){
       		axios.post(url, {params: this.tableData})
       		.then(response => {
       			this.auctions = response.data.data.data;
       			this.configPagination(response.data.data);
       		})
       	},
       	
       	getAvailableLots(){
       		axios.post("/api/getAvailableLots")
       		.then(response => {
       			this.lots = response.data.data.data;
       		})
       	},
       	
       	addModal(id){
       		axios.post("/api/getAuctionLots", {id: id, am: 'false', user_id: this.$userId})
       		.then(response => {
       			this.auction_lots = response.data;
       		})
       		$("#addModal").modal("show");
       		this.auction_id = id;
       	},
       	
       	details(id){
       		window.open('/home/buyer/lot-details/'+id)
       	},
       	
       	autoModal(id){
       		this.form.reset();
       		//this.form.auction_lot_id = id;
       		axios.post("/api/getAutoBid", {id: id, buyer_id: this.$userId})
       		.then(response => {
       			if(response.data.length != 0){
       				this.form.fill(response.data);
       				this.form.auction_lot_id = id;
       			}
       			else
       				this.form.auction_lot_id = id;
       			$("#autoModal").modal("show");
       		})
       	},
       	
       	setAutoBid(){
       		this.form.post("/api/setAutoBid")
       		.then(() => {
       			toast.fire({
       				type: "success",
       				title: "Auto Bid Set"
       			})
       		})
       		.catch(() => {
       			toast.fire({
       				type: "error",
       				title: "Failed"
       			})
       		})
       	},
       	
       	favourite(id, auction){
       		axios.post("/api/wishlistAdd", {user_id: this.$userId, auction_id: auction, auction_lot_id: id})
       		.then(response => {
       			if(response.data == 200)
       				toast.fire({
       					type: "success",
       					title: "Added to Wishlist"
       				})
       			else if(response.data == 500)
       				toast.fire({
       					type: "error",
       					title: "Already in Wishlist"
       				})
       		})
       	}
      }
    }
</script>
